const ContentContainer = ({ children }) => {
  return (
    <div className="bg-base-200 p-4 my-4 card border border-base-content/20">
      {children}
    </div>
  );
};

export default ContentContainer;
